var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepGuideBadges({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "badgeShadow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 3,
    floodColor: "#000000",
    floodOpacity: 0.55
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Helvetica, Arial, sans-serif",
    fontSize: 36,
    fontWeight: 700,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#badgeShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 111,
    r: 31.5,
    fill: "#9bdaf1",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 111,
    y: 111,
    fill: "#0b3d91",
    dominantBaseline: "central"
  }, "3")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#badgeShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 31.5,
    fill: "#2f6ea8",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 75,
    y: 75,
    fill: "#ffffff",
    dominantBaseline: "central"
  }, "2")), /*#__PURE__*/React.createElement("g", {
    filter: "url(#badgeShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 31.5,
    fill: "#0b3d91",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 39,
    y: 39,
    fill: "#ffffff",
    dominantBaseline: "central"
  }, "1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepGuideBadges);
export default __webpack_public_path__ + "static/media/step-guide-badges.37560f85a8d71117591c14ae0a387300.svg";
export { ForwardRef as ReactComponent };